import React, {Component} from 'react';
import moment from 'moment';
import './xeniagraphy.css'
import LOGO from '../xenia_logo_empty.png';
import logo_x from '../xenia_x.png';
import config from "../config.json";
import {BsFillArrowUpRightSquareFill, BsFillEyeFill} from "react-icons/bs";
import {AiFillEye} from "react-icons/all";


class Xeniagraphy extends Component {
    constructor(props) {
        super(props);
    }

    render() {
         if (!this.props.masterSubject.objectOfInteraction) {
             return (
                 <div></div>
             )
         }
             const oi = this.props.masterSubject.objectOfInteraction;
             const imageUrl = oi.imageUrl ? oi.imageUrl : LOGO;
             const websiteUrl = oi.xeniawaysUri;
             const title = oi.title ? oi.title : '--';
             const openIn = oi.xframeOptions ? oi.xframeOptions : 'false';
             const description = oi.description;
             const date = this.props.masterSubject.dateCreated ?
                 moment(this.props.masterSubject.dateCreated).format('DD/MM/YY') : '--';
            const dateUpdated = this.props.masterSubject.lastUpdateDate ?
            moment(this.props.masterSubject.lastUpdateDate).format('DD/MM/YY') : '--';
             const websiteIcon = oi.websiteIcon;
             const ms = this.props.masterSubject;
             const iframeSrc = config.widgetUrl_local + "/" + ms.uri.split('#')[1] + "/" + ms.templateIdCreatedFrom;
             const distance = ms.distance || '';


        return (
            <>
                    <div className="item-box-portal">
                        <div className="site-image-wrapper">
                            <img className="site-image" src={imageUrl}/>
                            {/*<div className="site-image-overlay">*/}
                                {/*<span>{date}</span>*/}
                                {/*<img className="site-favicon" src={websiteIcon}/>*/}
                            {/*</div>*/}
                        </div>
                        <div className="item-right">
                            <div className="item-title">
                                <span className="site-title">{title}</span>
                                {/*<img className="site-favicon" src={websiteIcon}/>*/}
                            </div>
                            <div className="separator">&nbsp;</div>
                            <div className="site-description">{description}</div>
                            <div className="site-footer">
                                <span>{dateUpdated}</span>
                                {this.props.showDistance ? <div className="distance-container">
                                    <div className="row">
                                        <div className="col-12">
                                            <span>Distance</span>
                                        </div>
                                        <div className="col-12">
                                            <span>{distance}</span>
                                        </div>
                                    </div>
                                </div> : null}
                                <div className="footer-corner">
                                    <span title="Requalifier l'objet" className="site-favicon icon-corner icon-requalifier" onClick={ ()=> this.props.handleOpenWebViewModal(window.widgetContextLink,"Requalifier l'objet",websiteUrl, ms.uriFamily.substring(29, 66))}><img  src={logo_x}/></span>
                                    <span title="Voir les indicateurs" className=" icon-corner icon-indicateurs" onClick={ ()=> this.props.handleOpenWebViewModal(iframeSrc,"Xenia indicateurs")}><AiFillEye className="eye-icon"/></span>
                                    <span title="Ouvrir le lien" className="icon-corner icon-lien" onClick={ ()=> openIn==true ? this.props.handleOpenWebViewModal(websiteUrl,websiteUrl) : window.open(websiteUrl)}>
                                        {
                                            websiteIcon ?
                                        <img title="Ouvrir le lien" className="site-favicon" src={websiteIcon}/> : <BsFillArrowUpRightSquareFill className="open-link-icon"/>
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className="clear"></div>
            </>
        );
    }
    // }
}

export default Xeniagraphy;